import { makeStyles } from '@material-ui/core';

export const css = makeStyles((theme) => ({
  input: {
    color: theme.palette.text.primary
  },
  label: {
    color: theme.palette.text.primary
  }
}));
